import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

export default function RHFTextDelimiterField({
  name,
  helperText,
  type,
  inputMode,
  InputProps,
  inputProps,
  ...other
}) {
  const { control } = useFormContext();

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const parts = value.toString().replace(/ /g, '').split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const decimalPart = parts[1] !== undefined ? `.${parts[1]}` : '';
    return integerPart + decimalPart;
  };

  const parseNumber = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return value
      .toString()
      .replace(/[^0-9. ]/g, '')
      .replace(/(\s+)/g, ' ')
      .replace(',', '.')
      .replace(/(\.\d{3,})/g, (match) => match.slice(0, 3));
  };


  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type="text" // Всегда используем type="text" для отображения точки/запятой
          value={type === 'number' ? formatNumber(field.value) : field.value || ''}
          onChange={(event) => {
            const inputValue = event.target.value;
            if (type === 'number') {
              // Разрешаем цифры, точки, запятые и пробелы (для разделителей тысяч)
              const cleanedValue = inputValue
                .replace(/[^\d.,\s]/g, '') // Удаляем все, кроме цифр, точек, запятых и пробелов
                .replace(',', '.'); // Заменяем запятые на точки для унификации

              // Сохраняем числовое значение
              const parsedValue = parseNumber(cleanedValue);
              field.onChange(parsedValue);

              // Форматируем для отображения
              const formattedValue = formatNumber(parsedValue);
              event.target.value = formattedValue;
            } else {
              field.onChange(inputValue);
            }
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
          inputProps={{
            ...inputProps,
            inputMode: inputMode || (type === 'number' ? 'decimal' : undefined),
            pattern: type === 'number' ? '[0-9]*[.,]?[0-9]*' : undefined, // Для iOS
          }}
          InputProps={InputProps}
        />
      )}
    />
  );
}
